import {
    createCustomAlarmDefinitionMutation,
    getCustomAlarmDefinitionByIdQuery,
    getRegisteredEventsQuery,
    updateCustomAlarmDefinitionMutation,
} from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-custom-alarm-form/service/custom-alarm-form.queries';
import { admGraphqlRequest } from 'core/utils/backend-service';
import {
    CreateCustomAlarmDefinitionInput,
    UpdateCustomAlarmDefinitionInput,
} from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-custom-alarm-form/settings-devices-custom-alarm-form.model';
import {
    CustomAlarmDefinition,
    CustomAlarmDefinitionTrackableEvent,
} from 'modules/settings/pods/settings-devices/settings-devices-configuration/domain/custom-alarm-definition.vm';
import { mapCustomAlarmDefinitionFromApi } from 'modules/settings/pods/settings-devices/settings-devices-configuration/service/custom-alarm-definition.mapper';

export const createCustomAlarmDefinition = (definition: CreateCustomAlarmDefinitionInput): Promise<string> =>
    admGraphqlRequest(createCustomAlarmDefinitionMutation(), { definition }).then(
        (result) => result.data.createCustomAlarmDefinition
    );

export const getRegisteredEvents = (deviceTypeId: string): Promise<CustomAlarmDefinitionTrackableEvent[]> =>
    admGraphqlRequest(getRegisteredEventsQuery(), { type: 'DEVICE_TYPE', id: deviceTypeId }).then(
        (result) => result.data.registeredEvents
    );

export const getCustomAlarmDefinitionById = (id: string): Promise<CustomAlarmDefinition> =>
    admGraphqlRequest(getCustomAlarmDefinitionByIdQuery(), { id }).then((result) =>
        mapCustomAlarmDefinitionFromApi(result.data.customAlarmDefinition)
    );

export const updateCustomAlarmDefinition = (update: UpdateCustomAlarmDefinitionInput, id: string): Promise<void> =>
    admGraphqlRequest(updateCustomAlarmDefinitionMutation(), { update, id }).then(
        (result) => result.data.updateCustomAlarmDefinition
    );
